import './style.css';

const Loading = () => (
    <div className="spinner-container">
        <div className="spinner"></div>
    </div>
);

export default Loading;